import { FC } from 'react';
import Box from '@mui/material/Box';
import { SkeletonBar } from '../../../reusable-components/data-table/TableSkeleton';
import './messagingSkeleton.scss';

const MESSAGES = [
  { outgoing: false, chainTop: true, widths: [62, 44] },
  { outgoing: false, chainTop: false, widths: [38] },
  { outgoing: true, chainTop: true, widths: [54] },
  { outgoing: false, chainTop: true, widths: [70, 52, 30] },
  { outgoing: true, chainTop: true, widths: [46, 28] },
  { outgoing: true, chainTop: false, widths: [34] },
];

export const ConversationMessagesSkeleton: FC<{ className?: string; withInput?: boolean }> = ({
  className,
  withInput = true,
}) => (
  <Box className={`conversationSkeleton__body ${className ?? ''}`} role="status" aria-label="Loading messages">
    <Box className="conversationSkeleton__messages">
      {MESSAGES.map((message, index) => {
        const longest = Math.max(...message.widths);
        const nextIsSameSide = MESSAGES[index + 1]?.outgoing === message.outgoing && !MESSAGES[index + 1]?.chainTop;
        return (
          <Box
            key={index}
            className={`conversationSkeleton__message ${message.outgoing ? 'conversationSkeleton__message--outgoing' : ''} ${
              nextIsSameSide ? 'conversationSkeleton__message--chained' : ''
            }`}
          >
            {!message.outgoing ? (
              <Box className="conversationSkeleton__avatarSlot">
                {!nextIsSameSide ? <SkeletonBar width={28} height={28} radius={14} /> : null}
              </Box>
            ) : null}
            <Box className="conversationSkeleton__bubbleColumn" sx={{ width: `min(470px, ${longest}%)` }}>
              {!message.outgoing && message.chainTop ? <SkeletonBar width={90} height={10} /> : null}
              <Box className="conversationSkeleton__bubble">
                {message.widths.map((width, line) => (
                  <Box key={line} className="conversationSkeleton__line" sx={{ width: `${(width / longest) * 100}%` }} />
                ))}
              </Box>
            </Box>
            <SkeletonBar width={36} height={8} />
          </Box>
        );
      })}
    </Box>
    {withInput ? (
      <Box className="conversationSkeleton__footer">
        <Box className="conversationSkeleton__input" />
        <SkeletonBar width={24} height={24} radius={12} />
        <SkeletonBar width={24} height={24} radius={12} />
      </Box>
    ) : null}
  </Box>
);

export const ConversationSkeleton: FC<{ variant: 'event' | 'support' }> = ({ variant }) => (
  <Box className={`conversationSkeleton conversationSkeleton--${variant}`} role="status" aria-label="Loading conversation">
    <Box className="conversationSkeleton__header">
      <Box className="conversationSkeleton__avatar" />
      <Box className="conversationSkeleton__headerText">
        <SkeletonBar width={variant === 'event' ? '46%' : '38%'} height={18} />
        {variant === 'event' ? <SkeletonBar width="72%" height={12} /> : null}
      </Box>
      {variant === 'event' ? (
        <Box className="conversationSkeleton__headerActions">
          <SkeletonBar width={32} height={32} radius={16} />
          <SkeletonBar width={32} height={32} radius={16} />
        </Box>
      ) : null}
    </Box>
    <ConversationMessagesSkeleton />
  </Box>
);
